import { useState } from "react";
import axios from "axios";

import { bannerData } from "../../../globals/banner";
import Banner from "../../sections/common/banner";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaPaperPlane,
} from "react-icons/fa";
import Seo from "../common/Seo";

function ContactUsPage() {
  /* =======================
     STATE MANAGEMENT
  ======================= */
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  /* =======================
     INPUT HANDLER
  ======================= */
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /* =======================
     FORM SUBMIT HANDLER
  ======================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await axios.post(
        `${process.env.REACT_APP_CONTACT_API}/api/contact/submit`,
        { ...formData, domain: "darchtech.com" },
        { headers: { "Content-Type": "application/json" } }
      );

      alert("Message sent successfully!");

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      alert("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo
        title="Contact DArchTech | Get a Free Consultation"
        description="Get in touch with DArchTech for expert digital solutions. Contact us today for a free consultation and start your digital growth journey."
      />

      {/* Banner */}
      <Banner _data={bannerData.contact} />

      {/* CONTACT US SECTION START */}
      <div className="section-full p-t110 p-b80 sx-bg-white">
        <div className="container">
          <div className="section-content">
            <div className="row justify-content-center">
              {/* LEFT: CONTACT DETAILS */}
              <div className="col-lg-8 col-md-12 m-b30">
                <div className="contact-info">
                  {/* Heading */}
                  <div className="section-head left">
                    <div
                      className="sx-head-s-title"
                      style={{ color: "#116A7A" }}
                    >
                      Contact Us
                    </div>
                    <div className="sx-head-l-title">
                      <h2 className="sx-title" style={{ color: "#116A7A" }}>
                        Let's Discuss Your Project & Digital Growth
                      </h2>
                    </div>
                  </div>

                  {/* Contact Cards */}
                  <div className="row sx-contact-form-icon-bx">
                    {/* Phone */}
                    <div className="col-lg-6 col-md-6 m-b30">
                      <div className="sx-icon-bx-5">
                        <div className="sx-media">
                          <FaPhoneAlt size={26} color="#116A7A" />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title-info">Call Us</span>
                          <a
                            href="tel:+7558307059"
                            className="sx-icon-bx-title"
                          >
                            +91 7558307059 / 9623922545
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-lg-6 col-md-6 m-b30">
                      <div className="sx-icon-bx-5">
                        <div className="sx-media">
                          <FaEnvelope size={26} color="#116A7A" />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title-info">
                            Email Us
                          </span>
                          <a
                            href="mailto:info@darchtech.com"
                            className="sx-icon-bx-title"
                          >
                            admin@darchtech.com
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Location */}
                    <div className="col-lg-6 col-md-6 m-b30">
                      <div className="sx-icon-bx-5">
                        <div className="sx-media">
                          <FaMapMarkerAlt size={26} color="#116A7A" />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title-info">
                            Office Address
                          </span>
                          <span className="sx-icon-bx-title">
                            Rajdhani Complex, Office No. B/317, 3th Floor, Near
                            Shankar Maharaj Math Pune - Satara Road, Pune-411043
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Office Time */}
                    <div className="col-lg-6 col-md-6 m-b30">
                      <div className="sx-icon-bx-5">
                        <div className="sx-media">
                          <FaClock size={26} color="#116A7A" />
                        </div>
                        <div className="sx-icon-bx-info">
                          <span className="sx-icon-bx-title-info">
                            Working Hours
                          </span>
                          <span className="sx-icon-bx-title">
                            Mon - Sun: 07:00 AM - 9:00 PM
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT: CONTACT FORM */}
              <div className="col-lg-4 col-md-12 m-b30">
                <div className="contact-home1-right">
                  <div
                    className="contact-home-1-form"
                    style={{ backgroundColor: "#f5f8fa" }}
                  >
                    <h4 className="sx-title" style={{ color: "#116A7A" }}>
                      Get In Touch
                    </h4>

                    <form className="cons-contact-form2 form-transparent">
                      <div className="input input-animate">
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          placeholder="Your Name"
                        />
                        <span className="spin" />
                      </div>

                      <div className="input input-animate">
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          placeholder="Your Email"
                        />
                        <span className="spin" />
                      </div>

                      <div className="input input-animate">
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          placeholder="Phone Number"
                        />
                        <span className="spin" />
                      </div>

                      <div className="input textarea input-animate">
                        <textarea
                          rows="4"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                          placeholder="Tell us about your project"
                        />
                        <span className="spin" />
                      </div>

                      <div className="sx-btn-center text-center p-t10">
                        <button
                          disabled={loading}
                          className="site-button sx-btn-primary sx-btn-lg"
                          style={{ backgroundColor: "#116A7A" }}
                          onClick={handleSubmit}
                        >
                          <FaPaperPlane className="me-2" />
                          {loading ? "Sending..." : "Send Message"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* CONTACT US SECTION END */}

      {/* GOOGLE MAP */}
      <div className="gmap-outline map-grayscle">
        <iframe
          src="https://www.google.com/maps?q=Rajdhani+Complex+Office+No+B+317+Near+Shankar+Maharaj+Math+Pune+Satara+Road+Pune+411043&output=embed"
          style={{ border: 0, width: "100%", height: "450px" }}
          allowFullScreen
          loading="lazy"
          title="DArchTech Office Location"
        />
      </div>
    </>
  );
}

export default ContactUsPage;
